export const AppointmentStatus = {
  CREATED: "CREATED",
  CANCELLED: "CANCELLED",
  CONFIRMED: "CONFIRMED",
  FULFILLED: "FULFILLED"
};
